<template>
  <div :class="$style.topbar">
    <div class="mr-4">
      <!-- <cui-fav-pages /> -->
    </div>
    <div class="mr-auto">
      <!-- <cui-search /> -->
    </div>
    <div class="mr-4 d-none d-md-block">
      <!-- <cui-issues-history /> -->
    </div>
    <div class="mr-4 d-none d-sm-block" v-if="role.toLowerCase() === 'astrazeneca' || role.toLowerCase() === 'apl'">
      <cui-actions />
    </div>
    <div class="mr-4 d-none d-sm-block">
      <div class='mt-3'>
        <p style="margin: 0; max-height: 20px;"> Welcome, <strong>{{ $store.state.user.email }} </strong></p>
        <p class="text-right"> <strong> {{ role }} </strong></p>
      </div>
    </div>

    <div>
      <cui-user-menu />
    </div>
  </div>
</template>

<script>
// import CuiIssuesHistory from './IssuesHistory'
// import CuiProjectManagement from './ProjectManagement'
// import CuiSearch from './Search'
// import CuiLanguageSwitcher from './LanguageSwitcher'
import CuiActions from './Actions'
import CuiUserMenu from './UserMenu'
// import CuiFavPages from './FavPages'
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
export default {
  data() {
    return {
      role: this.$store.state.user.role,
    }
  },
  mounted() {
    this.role = capitalizeFirstLetter(this.role)
  },
  components: {
    // CuiIssuesHistory,
    // CuiProjectManagement,
    // CuiSearch,
    // CuiLanguageSwitcher,
    CuiActions,
    CuiUserMenu,
    // CuiFavPages,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
